import React from 'react';
import { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  hint?: string;
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  hint,
  action,
  className = '',
}) => (
  <div
    className={`py-16 px-6 flex flex-col items-center justify-center text-center border border-dashed border-line rounded-sm ${className}`}
  >
    <Icon size={40} className="text-ink-faint mb-4" />
    <p className="display text-lg text-ink-muted">{title}</p>
    {hint && <p className="label-caps text-ink-faint mt-2">{hint}</p>}
    {action && <div className="mt-6">{action}</div>}
  </div>
);
